const enums = { maintenanceEventStatus: ['Upcoming', 'Pending', 'Completed', 'Closed', 'Cancelled'] };

export default enums;
